/*
 * GLIMORA Warenkorb-Erweiterungen (Eigenbau, Nov. 2026)
 * 1) Rabattcode-Feld im Warenkorb-Drawer (ersetzt die App "Dcart - Discount in Cart")
 *    -> Codes werden über /cart/update.js (Parameter "discount") direkt am Warenkorb hinterlegt
 *       und gehen automatisch mit in den Checkout.
 * 2) Gratis-Artikel-Wächter für die Bundles (ersetzt Kaching-Logik)
 *    -> Artikel mit Line-Property _gl_gift ("Produkt-IDs|Mindestmenge") werden entfernt bzw.
 *       reduziert, wenn die Set-Bedingung im Warenkorb nicht mehr erfüllt ist.
 */
(function () {
  if (window.__glCartInit) return;
  window.__glCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cart = null;
  var guardBusy = false;
  var msg = null; // { text, shown }

  var fm = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
  var TAG_ICON = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M10.3 1.6a1 1 0 0 0-.7-.3H2.3a1 1 0 0 0-1 1v7.3c0 .3.1.5.3.7l8.4 8.4a1 1 0 0 0 1.4 0l7.3-7.3a1 1 0 0 0 0-1.4zM5.8 7.3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>';

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function refresh(c) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: c } }));
  }

  /* ------------------------------------------------------------------ */
  /* 1) Gratis-Artikel-Wächter                                           */
  /* ------------------------------------------------------------------ */
  function guard(c) {
    if (!c || !c.items || guardBusy) return;
    var updates = {}, n = 0;
    c.items.forEach(function (g) {
      var p = g.properties && g.properties._gl_gift;
      if (!p) return;
      var parts = String(p).split('|');
      var ids = parts[0].split(',').map(Number);
      var min = parseInt(parts[1], 10) || 1;
      var count = c.items.reduce(function (a, i) {
        var isGift = i.properties && i.properties._gl_gift;
        return a + (!isGift && ids.indexOf(i.product_id) > -1 ? i.quantity : 0);
      }, 0);
      var allowed = Math.floor(count / min);
      if (g.quantity > allowed) { updates[g.key] = allowed; n++; }
    });
    if (!n) return;
    guardBusy = true;
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(getCart)
      .then(function (nc) { guardBusy = false; refresh(nc); })
      .catch(function () { guardBusy = false; });
  }

  /* ------------------------------------------------------------------ */
  /* 2) Rabattcode-Feld im Drawer                                        */
  /* ------------------------------------------------------------------ */
  function discountTitles(c) {
    var seen = {}, list = [];
    var add = function (app) {
      if (!app || !app.title) return;
      var k = app.title.toLowerCase();
      if (seen[k]) return;
      seen[k] = true;
      list.push({ title: app.title, type: app.type });
    };
    (c.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application); });
    });
    (c.cart_level_discount_applications || []).forEach(add);
    return list;
  }

  function inject() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || !cart) return;
    var footer = drawer.querySelector('.mini-cart__drawer-footer');
    if (!footer) return;
    var sub = footer.querySelector('[data-cart-subtotal]');
    var totalRow = sub ? sub.closest('div') : null;

    // Endsumme: Originalpreis durchgestrichen + Endpreis (inkl. aller Positionen, wie vorher bei Dcart).
    // Das Original-Feld [data-cart-subtotal] bleibt versteckt im DOM, weil prio-service.js hineinschreibt.
    if (sub) {
      sub.style.display = 'none';
      if (!sub._glObs) {
        // prio-service.js schreibt nach jeder Änderung in dieses Feld -> dann frisch laden und neu zeichnen
        sub._glObs = new MutationObserver(function () { scheduleVerify(150); });
        sub._glObs.observe(sub, { childList: true, characterData: true, subtree: true });
      }
      var disp = totalRow.querySelector('.gl-dc__total');
      if (!disp) {
        disp = document.createElement('span');
        disp.className = 'gl-dc__total';
        sub.parentNode.insertBefore(disp, sub);
      }
      disp.innerHTML = (cart.original_total_price > cart.total_price ? '<s class="gl-dc__strike">' + fm(cart.original_total_price) + '</s>' : '') +
        '<span>' + fm(cart.total_price) + '</span>';
    }

    var box = footer.querySelector('.gl-dc');
    if (!box) {
      box = document.createElement('div');
      box.className = 'gl-dc';
      if (totalRow && totalRow.parentNode === footer) totalRow.after(box);
      else footer.insertBefore(box, footer.querySelector('.checkout-button') || null);
    }

    var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toLowerCase(); });
    var titles = discountTitles(cart);
    var h = '';
    if (msg && msg.text) { h += '<p class="gl-dc__err" role="alert">' + esc(msg.text) + '</p>'; msg.shown = true; }
    h += '<div class="gl-dc__form"><label class="visually-hidden" for="gl-dc-input">Rabattcode eingeben</label>' +
      '<input id="gl-dc-input" class="gl-dc__input" type="text" placeholder="Rabattcode eingeben" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
      '<button type="button" class="gl-dc__btn" data-gl-dc-apply>Anwenden</button></div>';
    if (titles.length || cart.total_discount > 0) {
      h += '<div class="gl-dc__info">';
      if (titles.length) {
        h += '<div class="gl-dc__tags">';
        titles.forEach(function (t) {
          var isCode = codes.indexOf(t.title.toLowerCase()) > -1;
          h += '<span class="gl-dc__tag">' + TAG_ICON + '<span class="gl-dc__tag-name">' + esc(t.title) + '</span>' +
            (isCode ? '<button type="button" class="gl-dc__x" data-gl-dc-remove="' + esc(t.title) + '" aria-label="Rabattcode entfernen">&times;</button>' : '') + '</span>';
        });
        h += '</div>';
      }
      if (cart.total_discount > 0) {
        h += '<div class="gl-dc__row"><span>Rabatt:</span><span>-' + fm(cart.total_discount) + '</span></div>';
        h += '<div class="gl-dc__row"><span>Gesamt:</span><span>' + fm(cart.total_price) + '</span></div>';
      }
      h += '</div>';
    }
    box.innerHTML = h;
    renderedSig = sig(cart);
    scheduleVerify(600);
  }

  // Andere Scripts (z. B. prio-service.js) ändern den Warenkorb teils ohne Event.
  // Nach jedem Rendern frisch laden und nur neu zeichnen, wenn sich etwas gegenüber der Anzeige geändert hat.
  var verifyT = null, renderedSig = '';
  function sig(c) { return c ? [c.total_price, c.original_total_price, c.total_discount, c.item_count, JSON.stringify(c.discount_codes || [])].join('|') : ''; }
  function scheduleVerify(ms) {
    clearTimeout(verifyT);
    verifyT = setTimeout(function () {
      getCart().then(function (nc) { if (sig(nc) !== renderedSig) inject(); });
    }, ms || 600);
  }

  function setLoading(on) {
    var btn = document.querySelector('.gl-dc__btn');
    if (btn) { btn.disabled = on; btn.classList.toggle('is-loading', on); }
  }

  function updateCodes(list) {
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
      .then(function (r) { return r.json(); });
  }

  function apply(code) {
    code = (code || '').trim();
    if (!code) return;
    setLoading(true);
    (cart ? Promise.resolve(cart) : getCart()).then(function (c) {
      var existing = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (existing.some(function (x) { return x.toLowerCase() === code.toLowerCase(); })) { setLoading(false); return; }
      return updateCodes(existing.concat([code])).then(function (nc) {
        var hit = (nc.discount_codes || []).find(function (d) { return d.code.toLowerCase() === code.toLowerCase(); });
        if (!hit || !hit.applicable) {
          msg = { text: 'Dieser Rabattcode ist ungültig oder gilt nicht für die Artikel in deinem Warenkorb.', shown: false };
          return updateCodes(existing).then(getCart);
        }
        msg = null;
        return getCart();
      }).then(function (nc) { setLoading(false); refresh(nc); });
    }).catch(function () { setLoading(false); });
  }

  function removeCode(code) {
    (cart ? Promise.resolve(cart) : getCart()).then(function (c) {
      var rest = (c.discount_codes || []).filter(function (d) { return d.applicable && d.code.toLowerCase() !== code.toLowerCase(); }).map(function (d) { return d.code; });
      return updateCodes(rest).then(getCart).then(function (nc) { msg = null; refresh(nc); });
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-gl-dc-apply]');
    if (a) { e.preventDefault(); var inp = document.getElementById('gl-dc-input'); apply(inp && inp.value); return; }
    var r = e.target.closest('[data-gl-dc-remove]');
    if (r) { e.preventDefault(); removeCode(r.getAttribute('data-gl-dc-remove')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.target && e.target.id === 'gl-dc-input' && e.key === 'Enter') { e.preventDefault(); apply(e.target.value); }
  });

  function onCartEvent(e) {
    var c = e.detail && e.detail.cart;
    if (msg && msg.shown) msg = null;
    if (c && c.items) {
      cart = c;
      setTimeout(function () { guard(c); }, 50);
      inject();
    } else {
      getCart().then(function (nc) { inject(); guard(nc); });
    }
  }
  document.documentElement.addEventListener('cart:refresh', onCartEvent);
  document.documentElement.addEventListener('cart:updated', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && c.items) { cart = c; setTimeout(function () { guard(c); }, 50); }
  });

  function start() {
    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      new MutationObserver(function () { inject(); }).observe(drawer, { childList: true });
    }
    getCart().then(function (c) { inject(); guard(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
